module.exports = __webpack_public_path__ + "img/solution-data-logo4.4008ed44.png";